// 二维码处理方法
//字符串处理成二维码标准字符串<stn2>
export function txtToQRtxt(str,contentTxt) {
    let strLen = str.length;
    let interceptLen = 500;
    let counts = Math.floor(strLen / interceptLen);
    const arr = [];
    for (let i = 0; i <= counts; i++) {
        var curStr = str.substr(interceptLen * i, interceptLen);
        if (counts == 0) {
            curStr = contentTxt + `O$`.concat(curStr).concat(contentTxt);
        } else if (counts > 0) {
            if (i == 0) {
                curStr = contentTxt + `S${counts + 1}$`.concat(curStr).concat(contentTxt);
            } else if (i == counts) {
                curStr = contentTxt + `E$`.concat(curStr).concat(contentTxt);
            } else {
                curStr = contentTxt + `${i + 1}$`.concat(curStr).concat(contentTxt);
            }
        }
        if (curStr) {
            // curStr = this.toUtf8(curStr);
            arr.push(curStr);
        }
    }
    return arr;
}
// utf-8处理
export function toUtf8(str) {
    var out, //输出
        i, //字符索引
        len, //长度
        c; //charCodeAt 编码后的字符
    out = '';
    len = str.length;
    for (i = 0; i < len; i++) {
        c = str.charCodeAt(i);
        if (c >= 0x0001 && c <= 0x007f) {
            out += str.charAt(i);
        } else if (c > 0x07ff) {
            out += String.fromCharCode(0xe0 | ((c >> 12) & 0x0f));
            out += String.fromCharCode(0x80 | ((c >> 6) & 0x3f));
            out += String.fromCharCode(0x80 | ((c >> 0) & 0x3f));
        } else {
            out += String.fromCharCode(0xc0 | ((c >> 6) & 0x1f));
            out += String.fromCharCode(0x80 | ((c >> 0) & 0x3f));
        }
    }
    return out;
}
   // 导出xml
   export function downFileData(fileName,data) {
      let blob = new Blob([data]);
      let downloadElement = document.createElement("a");
      let href = window.URL.createObjectURL(blob); //创建下载的链接
      downloadElement.href = href;
      downloadElement.download = fileName; //下载后文件名
      document.body.appendChild(downloadElement);
      downloadElement.click(); //点击下载
      document.body.removeChild(downloadElement); //下载完成移除元素
      window.URL.revokeObjectURL(href); //释放blob对象
}
